import { dateValidationFunctions } from './validations/date-validation-functions/date-validation-functions';
import { licenseLastNameValidationFunctions } from './validations/license-last-name-validation-functions/license-last-name-validation-functions';

export const initializeFunctions = () => {
  dateValidationFunctions();
  licenseLastNameValidationFunctions();
};

